
export function getNowFormatDate(val) {
  let date = new Date(), year = date.getFullYear(), month = date.getMonth() + 1, strDate = date.getDate() + val
  let days = new Date(year, month + 1, 0).getDate()
  if (strDate > days) {
    month = month + 1
    strDate = strDate - days
    var newDays = new Date(year, month + 2, 0).getDate()
    if (strDate > newDays) {
      month = month + 1
      strDate = strDate - newDays
    }
  }
  if (month > 12) {
    year = year + 1
    month = month - 12
  }
  if (month < 10) {
    month = `0${month}`
  }
  if (strDate < 10) {
    strDate = `0${strDate}`
  }
  return `${year}-${month}-${strDate}`
}
export function filter_date(dateStr) {
  const date = new Date(dateStr);
  const dayarray = new Array(
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  );
  const montharray = new Array(
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  );
  return `${dayarray[date.getDay()]} , ${montharray[date.getMonth()]
    } ${date.getDate()}`;
}

